<template>
  <div class="w-full">
    <SelectInput
      v-model="choiceValue"
      :name="name"
      :label="label"
      :placeholder="placeholder"
      :options="options"
      :body-render="false"
      :filter="filter"
      :filter-placeholder="filterPlaceholder"
      show-new-item
      options-class="!max-h-[85px]"
      @add-item="toggleAddModal"
    ></SelectInput>
    <Modal
      v-if="addModal"
      title="Add Item"
      @submit="submitItem"
      @hide-modal="toggleAddModal"
    >
      <div>
        <InputField
          v-model="item"
          title="Enter Item"
          :validation="error ? 'error' : ''"
          :helper-text="error"
        />
      </div>
    </Modal>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";

import Modal from "@/components/Modal.vue";
import InputField from "@/components/Seranova/InputField/InputField.vue";
import SelectInput from "@/components/Seranova/SelectInput/SelectInput.vue";

const store = useStore();

const emit = defineEmits(["update:modelValue"]);
const props = defineProps<{
  name: string;
  label?: string;
  placeholder?: string;
  modelValue?: string | null;
  type: string;
  filter?: boolean | null;
  filterPlaceholder?: string | null;
}>();

interface Option {
  value: string | null;
  label: string;
}
const item = ref("");
const options = ref<Option[]>([]);
const addModal = ref(false);
const error = ref("");

const choiceValue = computed({
  get() {
    return props.modelValue;
  },
  set(val) {
    emit("update:modelValue", val);
  }
});

onMounted(async () => {
  if (props.type) {
    const res = await store.dispatch("fetchChoices", props.type);
    formatOptions(res.data);
  }
});

const formatOptions = (data) => {
  options.value = data.map((option) => {
    return {
      value: option,
      label: option
    };
  });
};

const submitItem = async () => {
  if (!item.value) {
    error.value = "Value required";
    return;
  }
  error.value = "";
  emit("update:modelValue", item.value);
  options.value.push({
    value: item.value,
    label: item.value
  });
  addModal.value = false;
};

const toggleAddModal = () => {
  addModal.value = !addModal.value;
};
</script>

<style lang="scss" scoped></style>
